// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PjaqIyUwNAoxVg68QAxa {
    position: relative;
    display: flex;
    height: 100vh;
    flex-direction: column;
    align-items: center;
    justify-content: center
}
.UfzQIZ_G2V5jUppnp7ir {
    position: absolute;
    top: 0px;
    right: 0px
}
.xVDe_rDhTz8WR7WsEHtg {
    position: absolute;
    bottom: 0px;
    left: 0px
}
.Xy_pg4M_DonnZE32xx1S {
    position: relative;
    display: inline-block
}
.JjroEJPa5tfsxDSo5PwJ {
    display: block;
    max-width: 100%
}
.pNf7c4x3CPd7KJHxYpRX {
    position: absolute;
    top: 50%;
    left: 50%;
    --tw-translate-x: -50%;
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    font-size: 4.5rem;
    line-height: 1;
    font-weight: 700;
    --tw-text-opacity: 1;
    color: rgb(3 120 209 / var(--tw-text-opacity, 1))
}
.JDPO0OgkZAVOFaWUg4Oj {
    position: absolute;
    left: 50%;
    --tw-translate-x: -50%;
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(3 120 209 / var(--tw-text-opacity, 1))
}
.voRkzI8CkrfkwGc5xBaa {
    margin-top: 1rem;
    margin-bottom: 0.75rem;
    text-align: center;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 400;
    --tw-text-opacity: 1;
    color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
.QCGz56nZQyWHPvwpI02N {
    height: 38px;
    width: 120px;
    --tw-bg-opacity: 1;
    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
.QCGz56nZQyWHPvwpI02N:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}
.sqXubIIXb03QAvo_tNWr {
    display: flex;
    width: 100%;
    justify-content: center
}
`, "",{"version":3,"sources":["webpack://./src/pages/NotFound/styles.module.css"],"names":[],"mappings":"AACE;IAAA,kBAAkE;IAAlE,aAAkE;IAAlE,aAAkE;IAAlE,sBAAkE;IAAlE,mBAAkE;IAAlE;AAAkE;AAGlE;IAAA,kBAA6B;IAA7B,QAA6B;IAA7B;AAA6B;AAG7B;IAAA,kBAA+B;IAA/B,WAA+B;IAA/B;AAA+B;AAG/B;IAAA,kBAA4B;IAA5B;AAA4B;AAG5B;IAAA,cAAuB;IAAvB;AAAuB;AAGvB;IAAA,kBAAkG;IAAlG,QAAkG;IAAlG,SAAkG;IAAlG,sBAAkG;IAAlG,sBAAkG;IAAlG,+LAAkG;IAAlG,iBAAkG;IAAlG,cAAkG;IAAlG,gBAAkG;IAAlG,oBAAkG;IAAlG;AAAkG;AAGlG;IAAA,kBAA8F;IAA9F,SAA8F;IAA9F,sBAA8F;IAA9F,sBAA8F;IAA9F,+LAA8F;IAA9F,iBAA8F;IAA9F,iBAA8F;IAA9F,gBAA8F;IAA9F,oBAA8F;IAA9F;AAA8F;AAG9F;IAAA,gBAA+D;IAA/D,sBAA+D;IAA/D,kBAA+D;IAA/D,mBAA+D;IAA/D,oBAA+D;IAA/D,gBAA+D;IAA/D,oBAA+D;IAA/D;AAA+D;AAG/D;IAAA,YAA+C;IAA/C,YAA+C;IAA/C,kBAA+C;IAA/C,0DAA+C;IAA/C,oBAA+C;IAA/C;AAA+C;AAG/C;IAAA,6BAA8B;IAA9B,qEAA8B;IAA9B,+BAA8B;IAA9B;AAA8B;AAG9B;IAAA,aAAiC;IAAjC,WAAiC;IAAjC;AAAiC","sourcesContent":[".notFoundWrapper {\n  @apply relative h-screen flex flex-col justify-center items-center;\n}\n.topImage {\n  @apply absolute top-0 right-0;\n}\n.bottomImage {\n  @apply absolute bottom-0 left-0;\n}\n.innerImageWrapper {\n  @apply relative inline-block;\n}\n.innerImage {\n  @apply max-w-full block;\n}\n.wrapper404 {\n  @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-7xl font-bold text-primary;\n}\n.title {\n  @apply absolute left-1/2 -translate-x-1/2 -translate-y-1/2 text-2xl font-semibold text-primary;\n}\n.description {\n  @apply text-center  text-gray-500 text-sm font-normal mt-4 mb-3;\n}\n.homeButton {\n  @apply bg-primary text-white w-[120px] h-[38px];\n}\n.homeButton:hover {\n  @apply !bg-primary !text-white;\n}\n.buttonWrapper {\n  @apply w-full flex justify-center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notFoundWrapper": `PjaqIyUwNAoxVg68QAxa`,
	"topImage": `UfzQIZ_G2V5jUppnp7ir`,
	"bottomImage": `xVDe_rDhTz8WR7WsEHtg`,
	"innerImageWrapper": `Xy_pg4M_DonnZE32xx1S`,
	"innerImage": `JjroEJPa5tfsxDSo5PwJ`,
	"wrapper404": `pNf7c4x3CPd7KJHxYpRX`,
	"title": `JDPO0OgkZAVOFaWUg4Oj`,
	"description": `voRkzI8CkrfkwGc5xBaa`,
	"homeButton": `QCGz56nZQyWHPvwpI02N`,
	"buttonWrapper": `sqXubIIXb03QAvo_tNWr`
};
export default ___CSS_LOADER_EXPORT___;
